<template>
  <div id="Nav">
    <bg-video ref="bv" filename="dsj" :class="{ blur }" autoplay :muted="true"/>
    <big-events v-if="beVisiable" @close="$router.push('/Part01/Island')"/>
    <guide-button class="btn-lt" @click.native="$router.push('/Experience')">返回</guide-button>
    <guide-button class="btn-rt" @click.native="handleNarrateEnded">继续</guide-button>
  </div>
</template>

<script>
import BigEvents from '@/views/SubPage/BigEvents'

export default {
  name: 'Nav',
  components: {
    BigEvents,
  },
  data () {
    return {
      blur: false,
      beVisiable: false,
    }
  },
  mounted () {
    this.$narrate.play('04', { btnText: '港珠澳大桥建设大事记', onended: this.handleNarrateEnded }).then(_ => {
      this.beVisiable = true
    })
  },
  methods: {
    handleNarrateEnded () {
      this.$narrate.skip()
      this.$refs.bv.pause()
      this.blur = true
    },
  },
}
</script>

